import React from "react";

const LoadingPage = () => {
	return (
		<>
			<div
				id="pageloader"
				className="pageloader is-left-to-right is-active"
			></div>
		</>
	);
};

export default LoadingPage;
